module.exports = __webpack_public_path__ + "static/media/upload-image-icon.3e046b57.svg";